import { render, staticRenderFns } from "./data_management_home.vue?vue&type=template&id=42ca8993&scoped=true&"
import script from "./data_management_home.vue?vue&type=script&lang=js&"
export * from "./data_management_home.vue?vue&type=script&lang=js&"
import style0 from "./data_management_home.vue?vue&type=style&index=0&id=42ca8993&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca8993",
  null
  
)

export default component.exports